import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/ratesSearch/:selected_ruralityTier?/:selected_state?",
    name: "ratesSearch",
    props: true,
    meta: {
      auth: false,
      title: 'Rates Database'
    },
    component: () =>
        import("../views/RatesSearch.vue")
  },
  {
    meta: {
      auth: false,
      title: 'Rurality Tier Search Tool'
    },
    path: "/",
    name: "ruralitySearch",
    component: () =>
        import("../views/RuralitySearch.vue")
  }
];

const router = new VueRouter({
  routes
});

export default router;
